import { create } from "zustand";

/** How long a focused settings card keeps its flash highlight (ms) — matches
 *  the CSS flash animation in globals.css. */
const FLASH_MS = 2500;

interface SettingsFocusState {
  /** The `id` of the SettingsCard a search result wants to reveal, or null. */
  focusId: string | null;
  /** Reveal the card with this id (scroll into view + flash). */
  focus: (id: string) => void;
  clear: () => void;
}

let flashTimer: ReturnType<typeof setTimeout> | null = null;

export const useSettingsFocusStore = create<SettingsFocusState>((set) => ({
  focusId: null,
  focus(id) {
    if (flashTimer) clearTimeout(flashTimer);
    set({ focusId: id });
    flashTimer = setTimeout(() => set({ focusId: null }), FLASH_MS);
  },
  clear() {
    if (flashTimer) clearTimeout(flashTimer);
    set({ focusId: null });
  },
}));
